import * as React from "react";
const SvgR5Robot24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 20,
        fill: "black",
        viewBox: "0 0 24 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 0H0v9h2V7h6v9a2.048 2.048 0 0 0 0 .1 3.5 3.5 0 0 0 6.44 1.9h3.12A3.5 3.5 0 0 0 24 16V0H1Zm21 12.937V7H10v5.937A3.5 3.5 0 0 1 14.999 16H17a3.5 3.5 0 0 1 5-3.063ZM9 5H2V2h20v3H9Zm1 11.1a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm9 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgR5Robot24Px;
